// Version : 0.0.2
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'REMOVE UNUSED LINES'
// Modified Date : 06/12/2025
import GoldLoanDisbursementTypes from './gold-loan-disbursement.types';

/** ***************** FETCH GOLD LOAN INDEX BASED ON GROUP START *********************** */
export const fetchGoldLoanIndexDisbursementStart = (fetchGroupMembers: any) => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_START,
	payload: fetchGroupMembers,
});

export const fetchGoldLoanIndexDisbursementSuccess = (successData: any) => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_SUCCESS,
	payload: successData,
});

export const fetchGoldLoanIndexDisbursementFailure = (failureData: any) => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_FAILURE,
	payload: failureData,
});

export const fetchGoldLoanIndexDisbursementResponseResetStart = () => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_RESPONSE_RESET_START,
});

export const fetchGoldLoanIndexDisbursementResponseChanged = () => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_RESPONSE_CHANGED,
});
/** ***************** FETCH GOLD LOAN INDEX BASED ON GROUP END *********************** */

/** ***************** FETCH GOLD LOAN INDEX BASED ON GROUP LIST START *********************** */
export const fetchGoldLoanIndexDisbursementListStart = (fetchGroupMembers: any) => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_START,
	payload: fetchGroupMembers,
});

export const fetchGoldLoanIndexDisbursementListSuccess = (successData: any) => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_SUCCESS,
	payload: successData,
});

export const fetchGoldLoanIndexDisbursementListFailure = (failureData: any) => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_FAILURE,
	payload: failureData,
});

export const fetchGoldLoanIndexDisbursementListResponseResetStart = () => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_RESPONSE_RESET_START,
});

export const fetchGoldLoanIndexDisbursementListResponseChanged = () => ({
	type: GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH GOLD LOAN INDEX BASED ON GROUP LIST END *********************** */

/** ***************** UPDATE GOLD LOAN DISBURSEMENT START *********************** */
export const updateGoldLoanDisbursementStart = (updateData: any) => ({
	type: GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_START,
	payload: updateData,
});

export const updateGoldLoanDisbursementSuccess = (successData: any) => ({
	type: GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_SUCCESS,
	payload: successData,
});

export const updateGoldLoanDisbursementFailure = (failureData: any) => ({
	type: GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_FAILURE,
	payload: failureData,
});

export const updateGoldLoanDisbursementResponseResetStart = () => ({
	type: GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_RESPONSE_RESET_START,
});

export const updateGoldLoanDisbursementResponseChanged = () => ({
	type: GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_RESPONSE_CHANGED,
});
/** ***************** UPDATE GOLD LOAN DISBURSEMENT END *********************** */
